import client from 'client';

export const DEFAULT_PAYMENT_PROVIDER_FLAGS = {
  enable_dwolla: true,
  enable_plaid: true,
  enable_usio: true,
  source: 'global',
};

/**
 * Propósito: Carga flags de enrollment (global o override de company).
 * Default all-on si falla, para no romper el flujo actual.
 */
export async function fetchPaymentProviderFlags(userId) {
  try {
    const path = userId ? `/company/payment-providers/${userId}` : '/company/payment-providers';
    const response = await client.get(path);
    const flags = response?.data || {};

    /**
     * Output:
     * @returns object — Flags resueltos
     *   - enable_dwolla: boolean
     *   - enable_plaid: boolean
     *   - enable_usio: boolean
     *   - source: 'company' | 'global'
     */
    return {
      enable_dwolla: flags.enable_dwolla !== false,
      enable_plaid: flags.enable_plaid !== false,
      enable_usio: flags.enable_usio !== false,
      source: flags.source || 'global',
    };
  } catch (error) {
    /**
     * Output:
     * @returns object — Defaults all-on cuando el API no responde
     */
    return { ...DEFAULT_PAYMENT_PROVIDER_FLAGS };
  }
}

/**
 * Propósito: Persiste flags globales (super-admin) o override de company.
 */
export async function savePaymentProviderFlags(flags, userId = null) {
  const path = userId ? `/company/payment-providers/${userId}` : '/company/payment-providers';
  const response = await client.put(path, {
    enable_dwolla: Boolean(flags.enable_dwolla),
    enable_plaid: Boolean(flags.enable_plaid),
    enable_usio: Boolean(flags.enable_usio),
  });

  /**
   * Output:
   * @returns object — Flags efectivos después de guardar
   */
  return response.data;
}
